module.exports = __webpack_public_path__ + "img/v3-var-prop-paste.63d7a45e.png";